import { render, staticRenderFns } from "./PaymentBlockHelperPopUp.vue?vue&type=template&id=6649051a&scoped=true&"
import script from "./PaymentBlockHelperPopUp.vue?vue&type=script&lang=ts&"
export * from "./PaymentBlockHelperPopUp.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentBlockHelperPopUp.vue?vue&type=style&index=0&id=6649051a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6649051a",
  null
  
)

export default component.exports